import { formatDate as formatInLanguage } from '../../i18n';
import { IReviewSummary } from '../../interfaces/appraisal.interface';

const today = (): string => {
    const d = new Date();
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

/**
 * Formats a `yyyy-MM-dd` date or an ISO date-time in the current language (Latin digits). Plain dates are read
 * as local dates, so they never shift a day with the time zone.
 */
export const formatDate = (value: string | null | undefined): string => {
    if (!value) return '—';
    const date = value.length === 10 ? new Date(`${value}T00:00:00`) : new Date(value);
    return Number.isNaN(date.getTime()) ? value : formatInLanguage(date);
};

const isPast = (date: string) => date.slice(0, 10) < today();

/** The employee's self review is still open and its due date has passed. */
export const isSelfOverdue = (r: Pick<IReviewSummary, 'cycleStatus' | 'status' | 'selfReviewDue'>) =>
    r.cycleStatus === 'ACTIVE' && r.status === 'PENDING' && isPast(r.selfReviewDue);

/** The reviewer's assessment is still open and its due date has passed. */
export const isManagerOverdue = (r: Pick<IReviewSummary, 'cycleStatus' | 'status' | 'managerReviewDue'>) =>
    r.cycleStatus === 'ACTIVE' && (r.status === 'PENDING' || r.status === 'SELF_SUBMITTED') && isPast(r.managerReviewDue);
